import axios from './axios';

export const hasProductPricing = (payload, partnerProductId = 0) => {
  const url = '/Merchandising/Pricing/ProductPrice';
  return axios.post(url, payload, {
    params: {
      partnerProductId,
    },
    withCredentials: true,
    crossDomain: true,
  })
    .then(response =>
      response.status === 200 && !!response.data)
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error(error);
      return false;
    });
};


export default hasProductPricing;
